import { render, staticRenderFns } from "./PageHeadHandler.vue?vue&type=template&id=29bc4787&scoped=true&"
import script from "./PageHeadHandler.vue?vue&type=script&lang=js&"
export * from "./PageHeadHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc4787",
  null
  
)

export default component.exports